module.exports = __webpack_public_path__ + "202408221624/img/pic_guide_photo_2@2x.0af6b7eb.png";